import { ValueOf } from "core/types";
import { Banner } from "ds/ui";
import { useTranslations } from "translations";

export const HEADER_BANNERS = {
  IMPORT_WARNING: "import-warning",
} as const;

export type HeaderBannerType = ValueOf<typeof HEADER_BANNERS>;

export const HeaderBanners = ({
  banner,
  importData,
  onClose,
}: {
  banner: HeaderBannerType | null;
  importData: () => void;
  onClose: () => void;
}) => {
  const translations = useTranslations();

  switch (banner) {
    case HEADER_BANNERS.IMPORT_WARNING:
      return (
        <Banner
          actions={[
            {
              id: "refresh",
              label:
                translations.extractDocs.docsCreation.refreshWarningModal
                  .buttonRefresh,
              onPress: importData,
            },
          ]}
          color="warning"
          heading={
            translations.extractDocs.docsCreation.refreshWarningModal.title
          }
          message={
            translations.extractDocs.docsCreation.refreshWarningModal
              .description
          }
          withClose
          onClose={onClose}
        />
      );
    default:
      return null;
  }
};
